import type { PluginSimple } from 'markdown-it';
/**
 * A plugin that adds support for inline document annotations in Markdown.
 *
 *
 * Example:
 *
 * input:
 * ```md
 * @document:{id:1,file:http://google.com,file_name:File,created:2021-10-01T00:00:00.000Z,user_id:1,preview_url:,user_full_name:,user_avatar_url:}
 * ```
 *
 * output:
 * ```js
 *  {
 *   "type": "document",
 *   "attrs": {
 *     "id": 1,
 *     "file": "http://google.com",
 *     "file_name": "File",
 *     "created": "2021-10-01T00:00:00.000Z",
 *     "user_id": 1,
 *     "preview_url": "",
 *     "user_full_name": "",
 *     "user_avatar_url": ""
 *   }
 *  }
 * ```
 *
 * @param md - The Markdown-it instance.
 */
export const documentPlugin: PluginSimple = (md) => {
  md.block.ruler.before(
    'table',
    'document',
    (state, startLine, _endLine, silent) => {
      const lineText = state.src.slice(state.bMarks[startLine] + state.tShift[startLine], state.eMarks[startLine]);
      const documentRegex = /@document:\{([^}]+)\}/;
      const match = documentRegex.exec(lineText);

      if (!match) return false;
      if (silent) return false;

      const token = state.push('document', 'div', 0);
      token.content = match[1];
      state.line = startLine + 1;

      return true;
    },
    {
      alt: ['paragraph', 'reference', 'blockquote', 'list'],
    }
  );
};
